import Noty from 'noty';

addEventListener("direct-upload:initialize", event => {
  const { detail } = event
  const { id } = detail
  const submit = document.getElementById('submit-button');

  submit.insertAdjacentHTML("afterend", `
    <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
      <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
      <span class="direct-upload__filename" id="progress-text">Uploading: 0%</span>
    </div>
  `)
})
 
addEventListener("direct-upload:start", event => {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.remove("direct-upload--pending")
})
 
addEventListener("direct-upload:progress", event => {
  const { id, progress } = event.detail
  const progressElement = document.getElementById(`direct-upload-progress-${id}`)
  const progressElementSpan = document.getElementById(`progress-text`)
	
  progressElement.style.width = `${progress}%`
	progressElementSpan.innerHTML = `Uploading: ${~~progress}%`	
})
 
addEventListener("direct-upload:error", event => {
  event.preventDefault()
  const { id, error } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--error")
  element.setAttribute("title", error)
  // hide the progress bar (we can't delete because it's referenced by other event listeners)
  element.style.display = 'none'
  // remove disabled attribute from submit button
  document.getElementById('submit-button').removeAttribute('disabled')
  // this is a duplicate error message, but in some cases the default is not triggered
  new Noty({
      type: 'error',
      layout: 'topCenter',
      theme: 'nest',
      text: "Your video could not be uploaded, please try again.",
      timeout: '4000',
      progressBar: true,
      closeWith: ['click', 'button'],
      killer: true,
      animation: {
          open: 'animated bounceInDown', // Animate.css class names
          close: 'animated bounceOutUp' // Animate.css class names
        }
  }).show()

  Rollbar.critical(error)
})
 
addEventListener("direct-upload:end", event => {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--complete")
})